module.exports = __webpack_public_path__ + "assets/closeCircle-410061.svg";